var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-row",
    { staticClass: "p-3" },
    [
      _c(
        "b-col",
        [
          _c(
            "b-card",
            { attrs: { "body-class": "row py-0" } },
            [
              _c(
                "b-col",
                {
                  staticClass:
                    "column-divider-right d-flex flex-column align-items-center py-4",
                  attrs: { cols: "12", sm: "6", lg: "3" },
                },
                [
                  _c(
                    "p",
                    {
                      staticClass: "state-name regular bold text-gray big-text",
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("campaigns.statistics.uniqueOpens")) +
                          "\n        "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("p", { staticClass: "state-total bold text-gray big" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.stats.open.unique) +
                        "\n        "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "state-count text-gray small m-1" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("campaigns.statistics.openRate")) +
                        ":\n          " +
                        _vm._s(_vm._f("parsePercentage")(_vm.stats.open.rate)) +
                        "\n        "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "state-count text-gray small" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("campaigns.statistics.totalOpens")) +
                        ": " +
                        _vm._s(_vm.stats.open.count) +
                        "\n        "
                    ),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "b-col",
                {
                  staticClass: "d-flex flex-column align-items-center py-4",
                  attrs: { cols: "12", sm: "6", lg: "3" },
                },
                [
                  _c(
                    "p",
                    {
                      staticClass: "state-name regular bold text-gray big-text",
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$tc("global.words.sent", 1)) +
                          "\n        "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("p", { staticClass: "state-total bold text-gray big" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.stats.send.count) +
                        "\n        "
                    ),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "b-col",
                {
                  staticClass:
                    "column-divider-right column-divider-left d-flex flex-column align-items-center py-4",
                  attrs: { cols: "12", sm: "6", lg: "3" },
                },
                [
                  _c(
                    "p",
                    {
                      staticClass: "state-name regular bold text-gray big-text",
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("global.words.delivered")) +
                          "\n        "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("p", { staticClass: "state-total bold text-gray big" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.stats.delivery.count) +
                        "\n        "
                    ),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "b-col",
                {
                  staticClass: "d-flex flex-column align-items-center py-4",
                  attrs: { cols: "12", sm: "6", lg: "3" },
                },
                [
                  _c(
                    "p",
                    {
                      staticClass: "state-name regular bold text-gray big-text",
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$tc("global.words.click", 2)) +
                          "\n        "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("p", { staticClass: "state-total bold text-gray big" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.stats.click.count) +
                        "\n        "
                    ),
                  ]),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            { staticClass: "justify-content-center pb-3" },
            [
              _c(
                "b-col",
                {
                  staticClass: "d-flex flex-row ln-40",
                  attrs: { cols: "12", md: "6" },
                },
                [
                  _c("span", { staticClass: "bold pr-1" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("campaigns.statistics.rejectedEmails")) +
                        ":\n        "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("span", [_vm._v(" " + _vm._s(_vm.stats.reject.count))]),
                ]
              ),
              _vm._v(" "),
              _c(
                "b-col",
                {
                  staticClass: "d-flex flex-row ln-40",
                  attrs: { cols: "12", md: "6" },
                },
                [
                  _c("span", { staticClass: "bold pr-1" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("campaigns.statistics.complaintsFiled")) +
                        ":\n        "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("span", [_vm._v(" " + _vm._s(_vm.stats.complaint.count))]),
                ]
              ),
              _vm._v(" "),
              _c(
                "b-col",
                {
                  staticClass: "d-flex flex-row ln-40",
                  attrs: { cols: "12", md: "6" },
                },
                [
                  _c("span", { staticClass: "bold pr-1" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("campaigns.statistics.bouncedEmails")) +
                        ":\n        "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("span", [_vm._v(" " + _vm._s(_vm.stats.bounce.count))]),
                ]
              ),
              _vm._v(" "),
              _c(
                "b-col",
                {
                  staticClass: "d-flex flex-row ln-40",
                  attrs: { cols: "12", md: "6" },
                },
                [
                  _c("span", { staticClass: "bold pr-1" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.$t("campaigns.statistics.renderingFailures")
                        ) +
                        ":\n        "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(" " + _vm._s(_vm.stats["rendering-failure"].count)),
                  ]),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { staticClass: "d-flex flex-column justify-content-end" },
                [
                  _c(
                    "simple-button",
                    {
                      attrs: {
                        "class-name": "btn-sm",
                        loading: _vm.downloadingCSV,
                        disabled: _vm.downloadingCSV,
                      },
                      on: { click: _vm.downloadCSV },
                    },
                    [
                      _c("icon", { attrs: { name: "download" } }),
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("global.actions.downloadCSV")) +
                          "\n        "
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }